export const prefix = '[Programs][Details]';
